<template>
  <el-alert
    class="email-phi-warning"
    type="warning"
    title="Voicemail emails may contain protected health information (PHI)."
    description="Only send to email addresses secured for PHI."
    :closable="false"
    show-icon
  />
</template>

<script>
// Shown when a voicemail box has email delivery enabled.
export default {
  name: "EmailPhiWarning"
};
</script>

<style scoped>
.email-phi-warning {
  margin-bottom: 10px;
}
</style>
